import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "@/components/templates/app-layout";
import HomePage from "@/pages/home";
import LoginPage from "@/pages/login";
import ForgotPasswordPage from "@/pages/forgot-password";
import ResetPasswordPage from "@/pages/reset-password";
import PreviewPage from "@/pages/preview";
import SitesPage from "@/pages/sites";
import NouveauSitePage from "@/pages/nouveau-site";
import SiteDetailPage from "@/pages/site-detail";
import ModifierSitePage from "@/pages/modifier-site";
import NouvelleZonePage from "@/pages/nouvelle-zone";
import ZoneDetailPage from "@/pages/zone-detail";
import ModifierZonePage from "@/pages/modifier-zone";
import PinDetailPage from "@/pages/pin-detail";
import CampagnesPage from "@/pages/campagnes";
import ExportsPage from "@/pages/exports";
import ReglagesPage from "@/pages/reglages";
import LibraryPage from "@/pages/library";
import RapportEditPage from "@/pages/rapport-edit";
import RapportPreviewPage from "@/pages/rapport-preview";

export const router = createBrowserRouter([
  // Pages publiques (sans AppLayout)
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "/preview", element: <PreviewPage /> },

  // Pages protégées (avec AppLayout + auth guard)
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "sites", element: <SitesPage /> },
      { path: "sites/nouveau", element: <NouveauSitePage /> },
      { path: "sites/:siteId", element: <SiteDetailPage /> },
      { path: "sites/:siteId/modifier", element: <ModifierSitePage /> },
      { path: "sites/:siteId/zones/nouveau", element: <NouvelleZonePage /> },
      { path: "sites/:siteId/zones/:zoneId", element: <ZoneDetailPage /> },
      { path: "sites/:siteId/zones/:zoneId/modifier", element: <ModifierZonePage /> },
      { path: "sites/:siteId/zones/:zoneId/pins/:pinId", element: <PinDetailPage /> },
      { path: "sites/:siteId/rapport", element: <RapportEditPage /> },
      { path: "sites/:siteId/rapport/preview", element: <RapportPreviewPage /> },
      { path: "campagnes", element: <CampagnesPage /> },
      { path: "exports", element: <ExportsPage /> },
      { path: "reglages", element: <ReglagesPage /> },
      { path: "library", element: <LibraryPage /> },
    ],
  },
]);
